import { useCallback, useEffect, useState } from "react";

const LS_KEY = "afterme_cookie_consent";

function readConsent() {
  try {
    return localStorage.getItem(LS_KEY);
  } catch {
    return null;
  }
}

function writeConsent(value) {
  try {
    localStorage.setItem(LS_KEY, value);
  } catch {
    /* ignore */
  }
}

/**
 * Lightweight consent surface for local session storage and future analytics.
 * Dismissal is stored client-side only.
 */
export function CookieConsent({ copy }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!readConsent()) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (visible) {
      document.body.classList.add("has-cookie-banner");
      return () => document.body.classList.remove("has-cookie-banner");
    }
    document.body.classList.remove("has-cookie-banner");
    return undefined;
  }, [visible]);

  const dismiss = useCallback((value) => {
    writeConsent(value);
    setVisible(false);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="cookie-consent-inner">
        <div className="cookie-consent-text">
          <h2 id="cookie-consent-title" className="cookie-consent-title">
            {copy.title}
          </h2>
          <p id="cookie-consent-desc" className="cookie-consent-desc">
            {copy.body}
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button type="button" className="cookie-consent-btn ghost" onClick={() => dismiss("essential")}>
            {copy.essentialOnly}
          </button>
          <button type="button" className="cookie-consent-btn primary" onClick={() => dismiss("all")}>
            {copy.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
